// Brochure palettes. The renderer reads a palette by id and maps the
// values to CSS variables — add/remove palettes here without touching components.

export const PALETTES = [
  {
    id: "midnight",
    label: "Midnight",
    bg: "#0f1226",
    bgSoft: "#1a1e3a",
    surface: "rgba(255,255,255,0.06)",
    accent: "#7c8cff",
    accentSoft: "#a9b4ff",
    text: "#f2f3ff",
    muted: "#b6bce0",
  },
  {
    id: "ivory",
    label: "Ivory",
    bg: "#f7f4ee",
    bgSoft: "#efe9dd",
    surface: "rgba(20,16,10,0.04)",
    accent: "#b08545",
    accentSoft: "#c9a878",
    text: "#241f17",
    muted: "#6b6253",
  },
  {
    id: "emerald",
    label: "Emerald",
    bg: "#06231d",
    bgSoft: "#0d3a30",
    surface: "rgba(255,255,255,0.06)",
    accent: "#34d6a3",
    accentSoft: "#7eecc7",
    text: "#eafff7",
    muted: "#a7d8c8",
  },
  {
    id: "rose",
    label: "Rose",
    bg: "#fdf2f4",
    bgSoft: "#f8e3e8",
    surface: "rgba(40,10,20,0.04)",
    accent: "#c0436a",
    accentSoft: "#e07d9b",
    text: "#2a1119",
    muted: "#7a5460",
  },
  {
    id: "slate",
    label: "Slate",
    bg: "#11161c",
    bgSoft: "#1b232d",
    surface: "rgba(255,255,255,0.05)",
    accent: "#5ec8e6",
    accentSoft: "#9adcf0",
    text: "#eef4f8",
    muted: "#a9bccb",
  },
  {
    id: "sapphire",
    label: "Sapphire",
    bg: "#081a2f",
    bgSoft: "#102b4a",
    surface: "rgba(255,255,255,0.06)",
    accent: "#ff9f68",
    accentSoft: "#ffc39f",
    text: "#eef7ff",
    muted: "#a9c4dc",
  },
  {
    id: "plum",
    label: "Plum",
    bg: "#24112f",
    bgSoft: "#3a1d49",
    surface: "rgba(255,255,255,0.06)",
    accent: "#7ee0c4",
    accentSoft: "#b5f1e0",
    text: "#fff3ff",
    muted: "#d2b7dc",
  },
  {
    id: "marigold",
    label: "Marigold",
    bg: "#fff6d8",
    bgSoft: "#ffe8a6",
    surface: "rgba(42,32,8,0.05)",
    accent: "#3657c9",
    accentSoft: "#6f88e8",
    text: "#241c08",
    muted: "#70633a",
  },
  {
    id: "aegean",
    label: "Aegean",
    bg: "#edf9fb",
    bgSoft: "#d4eef4",
    surface: "rgba(6,34,42,0.04)",
    accent: "#d45d4c",
    accentSoft: "#ef9184",
    text: "#0d2730",
    muted: "#55717a",
  },
  {
    id: "mulberry",
    label: "Mulberry",
    bg: "#2b0f1f",
    bgSoft: "#441a33",
    surface: "rgba(255,255,255,0.06)",
    accent: "#8fe08a",
    accentSoft: "#c2f0bd",
    text: "#fff2f8",
    muted: "#d8b0c4",
  },
  {
    id: "copper",
    label: "Copper",
    bg: "#1f130d",
    bgSoft: "#352016",
    surface: "rgba(255,255,255,0.06)",
    accent: "#45d3c2",
    accentSoft: "#8de8dc",
    text: "#fff3ea",
    muted: "#cfb29f",
  },
  {
    id: "orchid",
    label: "Orchid",
    bg: "#f8eefb",
    bgSoft: "#eedbf6",
    surface: "rgba(36,14,46,0.045)",
    accent: "#2d8c7f",
    accentSoft: "#62b9ad",
    text: "#24102c",
    muted: "#745a7d",
  },
  {
    id: "obsidian",
    label: "Obsidian",
    bg: "#0d1013",
    bgSoft: "#181f23",
    surface: "rgba(255,255,255,0.055)",
    accent: "#d7c46a",
    accentSoft: "#eee196",
    text: "#f3f5f4",
    muted: "#aeb8b4",
  },
  {
    id: "coral",
    label: "Coral",
    bg: "#fff0e8",
    bgSoft: "#ffd9cb",
    surface: "rgba(48,19,8,0.045)",
    accent: "#167c90",
    accentSoft: "#52adbd",
    text: "#2b170f",
    muted: "#7c5d51",
  },
  {
    id: "lilac",
    label: "Lilac",
    bg: "#151329",
    bgSoft: "#252146",
    surface: "rgba(255,255,255,0.06)",
    accent: "#f2b34f",
    accentSoft: "#ffd98a",
    text: "#f7f1ff",
    muted: "#c4badf",
  },
];

const byId = Object.fromEntries(PALETTES.map((p) => [p.id, p]));

export function getPalette(id) {
  return byId[id] ?? PALETTES[0];
}

// Maps a palette to CSS custom properties for inline style injection.
export function paletteVars(palette) {
  return {
    "--bg": palette.bg,
    "--bg-soft": palette.bgSoft,
    "--surface": palette.surface,
    "--accent": palette.accent,
    "--accent-soft": palette.accentSoft,
    "--text": palette.text,
    "--muted": palette.muted,
  };
}
